import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  error: false,
  initialSize: 'small',
  spid: {
    clientId: null,
    url: '',
  },
  urls: {
    api: '',
    base: '',
    desktop: 'https://www.blocket.se',
    ikea: '',
    glimrUrl: '',
    trustApiUrl: '',
    trustWidgetUrl: '',
    oldMobileUrl: '',
    loginUrl: '',
    logoutUrl: '',
  },
  tealium: {
    enabled: false,
    environment: '',
  },
  sentry: {
    token: '',
    environment: 'development',
  },
  language: {
    label: 'Svenska',
    id: 'sv',
  },
  messageCenter: {
    enabled: false,
    siteName: '',
    environment: '',
    features: {
      addAttachment: false,
      injectMetaTags: true,
    },
    tipAreaEnabled: true,
  },
  contentful: {
    communication: {
      id: '',
      name: '',
      deliveryToken: '',
      previewToken: '',
    },
    content: {
      id: '',
      name: '',
      deliveryToken: '',
      previewToken: '',
    },
  },
})

const config = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_ERROR:
      return state.set('error', payload)
    case actions.SET_SPID_CLIENT_ID:
      return state.setIn(['spid', 'clientId'], payload)
    case actions.SET_SENTRY_DSN:
      return state.setIn(['sentry', 'token'], payload)
    case actions.SET_SENTRY_ENVIRONMENT:
      return state.setIn(['sentry', 'environment'], payload)
    case actions.SET_SPID_URL:
      return state.setIn(['spid', 'url'], payload)
    case actions.SET_IKEA_BASE_URL:
      return state.setIn(['urls', 'ikea'], payload)
    case actions.SET_GLIMR_API_URL:
      return state.setIn(['urls', 'glimrUrl'], payload)
    case actions.SET_TRUST_API_URL:
      return state.setIn(['urls', 'trustApiUrl'], payload)
    case actions.SET_TRUST_WIDGET_URL:
      return state.setIn(['urls', 'trustWidgetUrl'], payload)
    case actions.SET_BASE_URL:
      return state.setIn(['urls', 'base'], payload)
    case actions.SET_API_URL:
      return state.setIn(['urls', 'api'], payload)
    case actions.SET_OLD_MOBILE_URL:
      return state.setIn(['urls', 'oldMobileUrl'], payload)
    case actions.SET_DESKTOP_URL:
      return state.setIn(['urls', 'desktop'], payload)
    case actions.SET_TEALIUM_CONFIG:
      return state.set('tealium', payload)
    case actions.SET_MESSAGE_CENTER_CONFIG:
      return state.set('messageCenter', state.messageCenter.merge(payload))
    case actions.SET_CONTENTFUL_CONFIG:
      return state.set('contentful', state.contentful.merge(payload))
    case actions.SET_LOGIN_URL:
      return state.setIn(['urls', 'loginUrl'], payload)
    case actions.SET_LOGOUT_URL:
      return state.setIn(['urls', 'logoutUrl'], payload)
    case actions.SET_INITIAL_SIZE:
      return state.set('initialSize', payload)
    default:
      return state
  }
}

export default config
